/** The chat frame's chrome. */
export default {
  loadingMessages: "Loading messages",
  noMessages: "No messages yet",
  streaming: "Streaming",
  read: "Read",
  sent: "Sent",
} as const;
